module.exports = __webpack_public_path__ + "img/14csm_Kurtz-Ersa-Technology-Wavesoldering-Header-900x675_7b8fce4c01.0c51637c.png";